import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraInlineBanner, SpecraSwitchField } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useEffect, useState } from 'react';
import { useSetPursuitGrowthHint } from './recompeteHooks';
/**
 * GRW-04 v2.1 (OD-19): the pursuit-side switch for the content-free "Growth
 * is working this" hint on the recompeted program. Mounted by the facts rail
 * (GRW-16) in `related` when the pursuit has a current contract. The switch
 * moves at once; a failed save puts it back and says why.
 */ export function GrowthHintControl({ captureProjectId, value, canEdit }) {
    const setHint = useSetPursuitGrowthHint();
    const [checked, setChecked] = useState(value);
    const [error, setError] = useState('');
    useEffect(()=>setChecked(value), [
        value
    ]);
    const save = (next)=>{
        setChecked(next);
        setError('');
        setHint.mutate({
            captureProjectId,
            showGrowthHintToDelivery: next
        }, {
            onError: (err)=>{
                setChecked(!next);
                setError(err instanceof Error ? err.message : 'The setting could not be saved.');
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraSwitchField, {
                controlProps: {
                    checked,
                    disabled: !canEdit || setHint.isPending,
                    onCheckedChange: save
                },
                "data-testid": Testids.pursuitRail.growthHint,
                description: "Shows a 'Growth is working this' chip to people who can read the contract this pursuit recompetes. They never see the pursuit's name or details. Your admin's access rules decide whether it shows.",
                label: "Let Delivery see Growth is working this"
            }),
            error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                "data-testid": Testids.pursuitRail.growthHintError,
                tone: "danger",
                variant: "framed",
                children: error
            })
        ]
    });
}
